import { timeToMinutes } from './timeToMinutes';

/**
 * Checks if current time is between open and close times
 * @param {string} currentTime - Current time "10:00AM"
 * @param {string} openTime - Opening time "9:00AM"
 * @param {string} closeTime - Closing time "5:00PM"
 * @returns {boolean} - True if current time is between open and close
 */
export const isTimeBetween = (currentTime, openTime, closeTime) => {
	const current = timeToMinutes(currentTime);
	const open = timeToMinutes(openTime);
	const close = timeToMinutes(closeTime);

	// Handle normal hours (open < close)
	if (open <= close) {
		return current >= open && current < close;
	}
	return false;
};
